import { memo } from "react";

function Icon_ThreeDGeoModel({ size = 24 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.5146 1.1264C11.8169 0.958571 12.1831 0.959334 12.4844 1.1264H12.4854L17.4316 3.87347C17.4569 3.88557 17.4825 3.89723 17.5068 3.91156C17.8122 4.09122 17.9999 4.4196 18 4.77386V7.52289L20.5146 6.1264C20.8242 5.9545 21.2016 5.9587 21.5068 6.13812C21.8121 6.31783 22 6.64619 22 7.00043V17.0004C21.9998 17.3634 21.8027 17.6982 21.4854 17.8745L12.4854 22.8745C12.1759 23.0462 11.7983 23.042 11.4932 22.8627C11.1879 22.6831 11.0002 22.3546 11 22.0004V19.2504L8.48535 20.6479C8.1843 20.8151 7.82014 20.814 7.51953 20.6489L7.51758 20.6537L2.51465 17.8735C2.50767 17.8696 2.50007 17.8668 2.49316 17.8627C2.18793 17.6831 2.00018 17.3546 2 17.0004V7.00043C2 6.63734 2.19731 6.30281 2.51465 6.1264L11.5146 1.1264ZM13 12.5883V20.3012L20 16.4116V8.69965L13 12.5883ZM4 16.4116L7 18.0776V10.3666L4 8.69965V16.4116ZM9 10.3618V18.0746L11 16.9633V12.0004C11 11.6373 11.1973 11.3028 11.5146 11.1264L16 8.63422V6.47308L9 10.3618ZM11 3.69965L5.05762 6.99945L7.99512 8.63226L14.9375 4.77582L12 3.14398L11 3.69965Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default memo(Icon_ThreeDGeoModel);
